import httpClient from "./httpClient";

const getAuth = (username,password) => httpClient.post("/auth/login",{
  password:password,
  userName:username,
})

const refreshToken = (accessToken,refreshToken) => httpClient.post("/Token/refresh", {accessToken :accessToken, refreshToken:refreshToken}, { headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` }})


export {
  getAuth ,
  refreshToken
}
